var input = document.querySelector("#phone");
var iti = window.intlTelInput(input, {
    autoInsertDialCode: false,
    showFlags: false,
    separateDialCode: true,
    countryOrder: ["tw", "hk", "my", "sg", "jp", "mo", "cn"],
});

iti.setCountry(
    iti.countries.find(
        (country) => country.dialCode === checkoutProfile.phone_country
    ).iso2
);

input.addEventListener("countrychange", (event) => {
    changeCheckoutProfile({
        name: "phone_country",
        value: `+${iti.getSelectedCountryData().dialCode}`,
    });
});

TPDirect.setupSDK(tappay.app_id, tappay.app_key, tappay.server_type);

TPDirect.card.setup({
    fields: {
        number: {
            element: "#card-number",
            placeholder: "**** **** **** ****",
        },
        expirationDate: {
            element: "#card-expire",
            placeholder: "MM / YY",
        },
        ccv: {
            element: "#card-ccv",
            placeholder: "CCV",
        },
    },
    styles: {
        input: {
            color: "#909493",
            "font-size": "14px",
        },
    },
    isMaskCreditCardNumber: true,
    maskCreditCardNumberRange: {
        beginIndex: 6,
        endIndex: 11,
    },
});

TPDirect.card.onUpdate((update) => {
    changeCheckoutProfile({
        name: "prime",
        value: null,
    });

    if (update.status.number === 0) {
        document
            .querySelector("#card-number")
            .parentElement.classList.remove("invalid");
    } else if (update.status.number === 2) {
        document
            .querySelector("#card-number")
            .parentElement.classList.add("invalid");
    }

    if (update.status.expiry === 0) {
        document
            .querySelector("#card-expire")
            .parentElement.classList.remove("invalid");
    } else if (update.status.expiry === 2) {
        document
            .querySelector("#card-expire")
            .parentElement.classList.add("invalid");
    }

    if (update.status.ccv === 0) {
        document
            .querySelector("#card-ccv")
            .parentElement.classList.remove("invalid");
    } else if (update.status.ccv === 2) {
        document
            .querySelector("#card-ccv")
            .parentElement.classList.add("invalid");
    }

    if (update.canGetPrime) {
        cardGetPrime();
    }
});

TPDirect.ccv.setup({
    fields: {
        ccv: {
            element: "#select-ccv",
            placeholder: "CCV",
        },
    },
    styles: {
        input: {
            color: "#909493",
            "font-size": "14px",
        },
    },
});

TPDirect.ccv.onUpdate((update) => {
    changeCheckoutProfile({
        name: "prime",
        value: null,
    });

    if (update.status.ccv === 0) {
        document
            .querySelector("#select-ccv")
            .parentElement.classList.remove("invalid");
    } else if (update.status.ccv === 2) {
        document
            .querySelector("#select-ccv")
            .parentElement.classList.add("invalid");
    }

    if (update.canGetPrime) {
        ccvGetPrime();
    }
});

function cardGetPrime() {
    TPDirect.card.getPrime((result) => {
        changeCheckoutProfile({
            name: "prime",
            value:
                result.status == 0 && result.msg == "Success" ? result : null,
        });
    });
}

function ccvGetPrime() {
    TPDirect.ccv.getPrime((error, response) => {
        if (error) {
            console.log(error);
            return;
        }

        changeCheckoutProfile({
            name: "prime",
            value:
                response.status == 0 && response.msg == "Success"
                    ? response
                    : null,
        });
    });
}

function linePayGetPrime() {
    TPDirect.linePay.getPrime(function (result) {
        changeCheckoutProfile({
            name: "prime",
            value:
                result.status == 0 && result.msg == "Success" ? result : null,
        });
    });
}

var pointPriceBtn = document.querySelectorAll(".point-price");

pointPriceBtn.forEach((pointBtn) => {
    pointBtn.addEventListener("click", (pointBtn) => {
        var removeElement = document.querySelector(".point-price.select");
        pointBtn = pointBtn.target.closest(".point-price");
        removeElement?.classList.remove("select");
        pointBtn.classList.add("select");

        changeCheckoutProfile({
            name: "product_uuid",
            value: pointBtn.dataset.uuid,
        });

        $.ajax({
            method: "POST",
            url: `${checkoutProfile.updateUrl}`,
            data: {
                product_uuid: pointBtn.dataset.uuid,
                qty: pointBtn.dataset.qty,
                remove_uuid: "all",
            },
            headers: {
                "X-CSRF-TOKEN": document
                    .getElementsByName("csrf-token")[0]
                    .getAttribute("content"),
            },
            dataType: "json",
            beforeSend: function () {},
            success: function () {},
            error: function () {},
        }).done((response) => {});
    });
});

var paymentTypeBtn = document.querySelectorAll(".payment-btn");
var selectCard = document.querySelector(".select-card");

paymentTypeBtn.forEach((typeBtn) => {
    typeBtn.addEventListener("click", (typeBtn) => {
        typeBtn = typeBtn.target.closest(".payment-btn");
        document
            .querySelector(".payment-btn.select")
            ?.classList.remove("select");
        typeBtn.classList.add("select");

        changeCheckoutProfile({
            name: "payment_type",
            value: typeBtn.dataset.type,
        });

        changeCheckoutProfile({
            name: "prime",
            value: null,
        });

        if (typeBtn.dataset.type === "card") {
            document.querySelector(".credit-card")?.classList.add("select");

            changeCheckoutProfile({
                name: "select_card",
                value: selectCard.value,
            });

            if (selectCard.value === "add") {
                cardGetPrime();
            } else {
                ccvGetPrime();
            }
        } else {
            document.querySelector(".credit-card")?.classList.remove("select");

            changeCheckoutProfile({
                name: "select_card",
                value: typeBtn.dataset.type,
            });

            switch (typeBtn.dataset.type) {
                case "linePay":
                    linePayGetPrime();
                    break;
            }
        }
    });
});

selectCard?.addEventListener("change", (selector) => {
    var newCard = document.querySelectorAll(".add-new-card");
    var selectCardCCV = document.querySelector(".select-card-ccv");

    changeCheckoutProfile({
        name: "prime",
        value: null,
    });

    if (selector.target.value === "add") {
        newCard.forEach((item) => {
            item.classList.remove("hide");
        });
        selectCardCCV.classList.add("hide");

        cardGetPrime();
    } else {
        newCard.forEach((item) => {
            item.classList.add("hide");
        });
        selectCardCCV.classList.remove("hide");

        ccvGetPrime();
    }

    changeCheckoutProfile(selector.target);
});

window.changeCheckoutProfile = function (event) {
    switch (event.name) {
        case "terms":
            checkoutProfile[event.name] = event.checked;
            break;
        case "first_name":
        case "last_name":
        case "email":
        case "phone":
        case "phone_country":
        case "payment_type":
        case "prime":
        case "product_uuid":
        case "select_card":
            checkoutProfile[event.name] = event.value;
            break;
    }

    var canSubmit = true;
    var checkValidity = true;

    if (typeof event.checkValidity === "function") {
        checkValidity = event.checkValidity();

        if (!checkValidity) {
            event.parentElement.classList.add("invalid");
        } else {
            event.parentElement.classList.remove("invalid");
        }
    }

    var inValidKey = "";
    var finalMessage = document.querySelector(".final-message");
    finalMessage.classList.remove("invalid");

    Object.keys(checkoutProfile).forEach((key, index) => {
        if (canSubmit) {
            canSubmit = !!checkoutProfile[key] && checkValidity;

            if (!canSubmit) {
                inValidKey = key;
                finalMessage.classList.add("invalid");
            }
        }
    });

    switch (inValidKey) {
        case "first_name":
        case "last_name":
        case "email":
        case "phone_country":
        case "phone":
            finalMessage.setAttribute(
                "data-text",
                checkoutProfileMessages.profile
            );
            break;
        case "payment_type":
        case "prime":
        case "select_card":
            finalMessage.setAttribute(
                "data-text",
                checkoutProfileMessages.select_card
            );
            break;
        case "terms":
            finalMessage.setAttribute(
                "data-text",
                checkoutProfileMessages.confirm_terms
            );
            break;
        case "product_uuid":
            finalMessage.setAttribute(
                "data-text",
                checkoutProfileMessages.select_point
            );
            break;
    }

    return canSubmit;
};

document.querySelector(".payment-pay").addEventListener("click", (event) => {
    if (changeCheckoutProfile("justCheck")) {
        switch (checkoutProfile.payment_type) {
            case "card":
                checkoutProfile.select_card === "add"
                    ? cardGetPrime()
                    : ccvGetPrime();
                break;
            case "linePay":
                linePayGetPrime();
                break;
            default:
                return;
        }

        event.target.closest("button").classList.add("disabled");
        document.querySelector(".spinner-border").classList.remove("d-none");

        setTimeout(() => {
            $.ajax({
                method: "POST",
                url: `${checkoutProfile.checkoutUrl}`,
                data: {
                    checkoutProfile,
                },
                headers: {
                    "X-CSRF-TOKEN": document
                        .getElementsByName("csrf-token")[0]
                        .getAttribute("content"),
                },
                dataType: "json",
                beforeSend: function () {},
                success: function () {
                    document
                        .querySelector(".spinner-border")
                        .classList.add("d-none");
                    event.target.closest("button").classList.remove("disabled");
                },
                error: function () {
                    document
                        .querySelector(".spinner-border")
                        .classList.add("d-none");
                    event.target.closest("button").classList.remove("disabled");
                },
            }).done((response) => {
                document
                    .querySelector(".spinner-border")
                    .classList.add("d-none");
                event.target.closest("button").classList.remove("disabled");
                try {
                    new URL(response);
                    window.location.href = response;
                } catch (err) {
                    return false;
                }
            });
        }, 2000);
    }
});

changeCheckoutProfile({
    name: "select_card",
    value: selectCard.value,
});

changeCheckoutProfile({
    name: "product_uuid",
    value: document.querySelector(".point-price.select")?.dataset.uuid,
});
